import React from 'react';
import styled from 'styled-components';
import { mediumMediaQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';

interface BotMapProps {
    isAirQualityBotMap?: boolean;
    isSparkBotMap?: boolean;
    mapContentText: string;
}

export const BotMap = ({ isAirQualityBotMap, isSparkBotMap, mapContentText='' }: BotMapProps): JSX.Element => {
    return (
        <BotMapContainer isAirQualityBotMap={isAirQualityBotMap} isSparkBotMap={isSparkBotMap}>
            <BotMapView>{mapContentText}</BotMapView>
        </BotMapContainer>
    );
};

export const BotMapView = styled.canvas`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #F9F9F9;
    color: #000000;
`;

interface BotMapContainerProps {
    isAirQualityBotMap?: boolean;
    isSparkBotMap?: boolean; 
}

export const BotMapContainer = styled.div<BotMapContainerProps>`
    display: flex;
    flex-direction: row;
    width: 100%;
    padding-right: 0;
    height: 100%;

    margin-left: ${({ isSparkBotMap, isAirQualityBotMap }) => isSparkBotMap || isAirQualityBotMap ? '10px' : '0px'};

    @media ${mediumMediaQuery} {
        width: ${({ isSparkBotMap }) => isSparkBotMap ? '52%' : '100%'};
        ${({ isSparkBotMap }) => isSparkBotMap && `
            height: 600px;
        `};
    }

    @media ${smallMediaQuery} {
        margin: 10px 0 0 0;
        ${({ isSparkBotMap }) => isSparkBotMap && `
            margin: 10px 0 10 0;
            height: 400px;
            width: 97%;
        `};
    }
`;

